import React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const Player: React.FC<Props> = ({ className, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M22,9H2V8A1,1,0,0,1,3,7H21a1,1,0,0,1,1,1Z"
        fill="currentColor"
      />
      <path
        d="M21,7H3A1,1,0,0,0,2,8V19a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V8A1,1,0,0,0,21,7ZM12,17.5a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,12,17.5Z"
        fill="currentColor"
      />
      <circle
        cx="12"
        cy="13"
        r="2.5"
        fill="white"
      />
    </svg>
  );
};

export default Player;